<div id="banner-drimer" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="portada-title-linea">
                    <p class="p-display-bold primary-900 mb-3">
                        <span id="banner-drimer-pretitle" class="border-y-1 border-primary-900">ÚLTIMOS TICKETS</span>
                    </p>
                    <h1 class="h1-display mb-2 primary-900">La plataforma con IA <br class="d-lg-none"> única<br class="d-none d-xl-block d-xxl-none"> en <br class="d-none d-lg-block d-xl-none d-xxl-block"> el sector Travel  </h1>
                </div>
                <div class="d-none d-lg-block">
                    <p class="p-display primary-900">
                        SEGO Venture presenta <span class="p-display-bold">Drimer</span>, la compañía que en menos <br class="d-xxl-none"> de dos años <br class="d-none d-xxl-block">  ha generado casi 2M€ en ventas, con un modelo <br class="d-xxl-none">de
                        negocio <br class="d-none d-xxl-block"> absolutamente novedoso.
                    </p>
                </div>
            </div>

            <div class="mt-3 mt-lg-4">
                <app-btn-click [btnId]="'btn-drimer'" [btnTitle]="'¡Descúbrelo ahora!'"
                    (isBtnClicked)="enviarEventoClick()"></app-btn-click>
            </div>
        </div>
    </div>
</div>